import styles from './gold-reader-chip.module.css';

export const GoldReaderChip = () => <div className={styles.GoldReaderChip}>Gold Reader</div>;
